import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withModalActions } from 'core/hocs';
import { FormattedTag } from 'core/components';
import { ModalWindow } from 'components/modal-window/modal-window';
import { MODAL_IDS } from 'src/constants';

import './promo-registration-modal.scss';

class PromoRegistrationModalUI extends Component {
  static propTypes = {
    closeAllModals: PropTypes.func.isRequired,
    openModalAndCloseOthers: PropTypes.func.isRequired,
  };

  getExternalContent = () => (
    <div className="position-relative promo-registration-modal-mob-close w-100 d-flex d-sm-none justify-content-center">
      <FormattedTag
        id="promo-registration-modal.mob-button"
        onClick={this.props.closeAllModals}
      />
    </div>
  );

  onButtonClick = () => {
    const { openModalAndCloseOthers } = this.props;

    openModalAndCloseOthers(MODAL_IDS.SIGN_UP);
  }

  render() {
    return (
      <ModalWindow
        id={MODAL_IDS.PROMO_REGISTRATION}
        coreProps={{ id: MODAL_IDS.PROMO_REGISTRATION }}
        className="promo-registration-modal"
        bodyClassName="d-flex d-sm-block flex-column align-items-center justify-content-sm-center h-100 text-center p-2_5 pb-4 p-sm-4"
        modalClassName="promo-registration-modal-bg"
        backdropClassName="promo-registration-modal-backdrop"
        contentClassName="promo-registration-modal-content"
        closeButtonClassName="d-none d-sm-block"
        externalDialogContentBelow={this.getExternalContent()}
        isModalCentered
        fade
      >
        <div className="d-flex flex-column align-items-center">
          <FormattedTag
            tag="div"
            id="promo-registration-modal.title"
            className="h2 mb-0"
          />
          <img
            src="/assets/public/images/registration-promo.png"
            className="my-1"
            alt=""
          />

          <div className="d-flex flex-column align-items-center">
            <FormattedTag
              tag="div"
              id="promo-registration-modal.subtitle"
              className="text-gray-20"
            />
          </div>

          <FormattedTag
            id="promo-registration-modal.button"
            type="primary"
            className="btn btn-primary btn-lg w-100 mt-3"
            onClick={this.onButtonClick}
          />
        </div>
      </ModalWindow>
    );
  }
}

export const PromoRegistrationModal = withModalActions(PromoRegistrationModalUI);
